module.exports = __webpack_public_path__ + "img/header-icon-1.69d1c3e6.png";